/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

window.Rails = require("@rails/ujs")

require("@rails/activestorage").start()
require("trix")
require("@rails/actiontext")

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

import LocalTime from "local-time"
LocalTime.start()

import "stylesheets/application.scss"

import "src/confirm"
import "src/direct_uploads"
import "src/forms"
import "src/timezone"
import "src/alerts"
import "src/modal"
import "src/truncate"
import "bootstrap";

import "magnific-popup";
import flatpickr from "flatpickr";

window._ = require("lodash")

import tippy from 'tippy.js'
document.addEventListener('DOMContentLoaded', () => {
  tippy(document.querySelectorAll('[data-tippy-content]'))
})

Rails.start()

flatpickr('.datepicker-js')

var cardAccordions = document.getElementsByClassName('card--accordion');
if (cardAccordions && cardAccordions.length > 0){
  for (var i = 0; i < cardAccordions.length; i++) {
    var header = cardAccordions[i].getElementsByClassName("card-header")[0]
    if (header) {
      header.addEventListener("click", function(event) {
        var card = event.currentTarget.parentElement;
        if (card.classList.contains("card--accordion-open")) {
          card.classList.remove("card--accordion-open");
        } else {
          card.classList.add("card--accordion-open");
        }
      })
    }
  }   
}

var toggle_sidebar = false,
toggle_topbar = false,
nav_open = 0,
topbar_open = 0;

if(!toggle_sidebar && $('.sidenav-toggler').length) {
  var toggle = $('.sidenav-toggler');

  toggle.on('click', function(){
    if (nav_open == 1){
      $('html').removeClass('nav_open');
      $('.body-overlay').remove();
      toggle.removeClass('toggled');
      nav_open = 0;
    }  else {
      $('html').addClass('nav_open');
      $('<div class="body-overlay"></div>').insertAfter('.nav-bottom');
      toggle.addClass('toggled');
      nav_open = 1;
    }
  });

  $('.wrapper').mouseup(function(e)
  {
    var subject = $('.nav-bottom'); 

    if(e.target.className != subject.attr('class') && !subject.has(e.target).length)
    {
      $('html').removeClass('nav_open');
      $('.body-overlay').remove();
      toggle.removeClass('toggled');
      nav_open = 0;
    }
  });

  $(".nav-bottom .close-menu").on('click', function(){
    $('html').removeClass('nav_open');
    $('.body-overlay').remove();
    toggle.removeClass('toggled');
    nav_open = 0;
  });

  toggle_sidebar = true;
}

if(!toggle_topbar) {
  var topbar = $('.topbar-toggler');

  topbar.on('click', function() {
    if (topbar_open == 1) {
      $('html').removeClass('topbar_open');
      topbar.removeClass('toggled');
      topbar_open = 0;
    } else {
      $('html').addClass('topbar_open');
      topbar.addClass('toggled');
      topbar_open = 1;
    }
  });
  toggle_topbar = true;
}

import $ from "jquery";

$(document).ready(function() {
  $('.popup-gallery').each(function() {
    $(this).magnificPopup({
      delegate: '.image-link',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        // titleSrc: function(item) {
        //   return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
        // }
      }
    });
  });

  $('.video-upload-block').each(function() {
    $(this).magnificPopup({
      delegate: '.video-modal',
      type:'inline',
    });
  })
});

// Dealing with Textarea Height
function calcHeight(value) {
  let numberOfLineBreaks = (value.match(/\n/g) || []).length;
  // min-height + lines x line-height + padding + border
  let newHeight = 20 + numberOfLineBreaks * 20 + 12 + 2;
  return newHeight;
}

let textarea = document.querySelector(".textarea-resizable");
if (textarea) {
  textarea.addEventListener("keyup", () => {
    textarea.style.height = calcHeight(textarea.value) + "px";
  }); 
  
  textarea.addEventListener("focus", () => {
    textarea.style.height = calcHeight(textarea.value) + "px";
  }); 
}

// JS For carousel

// duration of scroll animation
var scrollDuration = 300;
// paddles
var leftPaddle = document.getElementsByClassName('left-paddle');
var rightPaddle = document.getElementsByClassName('right-paddle');
// get items dimensions
var itemsLength = $('.item').length;
var itemSize = $('.item').outerWidth(true);
// get some relevant size for the paddle triggering point
var paddleMargin = 20;

// get wrapper width
var getMenuWrapperSize = function() {
	return $('.menu-wrapper').outerWidth();
}
var menuWrapperSize = getMenuWrapperSize();
// the wrapper is responsive
$(window).on('resize', function() {
	menuWrapperSize = getMenuWrapperSize();
});
// size of the visible part of the menu is equal as the wrapper size 
var menuVisibleSize = menuWrapperSize;

// get total width of all menu items
var getMenuSize = function() {
	return itemsLength * itemSize;
};
var menuSize = getMenuSize();
// get how much of menu is invisible
var menuInvisibleSize = menuSize - menuWrapperSize;

// get how much have we scrolled to the left
var getMenuPosition = function() {
  
	return $('.menu').scrollLeft();
};

// finally, what happens when we are actually scrolling the menu
$('.menu').on('scroll', function() {

	// get how much of menu is invisible
	menuInvisibleSize = menuSize - menuWrapperSize;
	// get how much have we scrolled so far
	var menuPosition = getMenuPosition();

	var menuEndOffset = menuInvisibleSize - paddleMargin;


	// show & hide the paddles 
	// depending on scroll position
	if (menuPosition <= paddleMargin) {
		$(leftPaddle).addClass('hidden');
		$(rightPaddle).removeClass('hidden');
	} else if (menuPosition < menuEndOffset) {
		// show both paddles in the middle
		$(leftPaddle).removeClass('hidden');
		$(rightPaddle).removeClass('hidden');
	} else if (menuPosition >= menuEndOffset) {
		$(leftPaddle).removeClass('hidden');
		$(rightPaddle).addClass('hidden');
}

});

$(function() {

  var listItems = $('.menu .item .nav-link');
var itemTextArray = $.map(listItems, function(item, index) {
   return $(item).attr('class');
});

if(itemTextArray.indexOf('nav-link active show') > 2){
  $('.menu').scrollLeft(150)
}
  
});


// scroll to left
$(rightPaddle).on('click', function() {
	$('.menu').animate( { scrollLeft: menuInvisibleSize}, scrollDuration);
});

// scroll to right
$(leftPaddle).on('click', function() {
	$('.menu').animate( { scrollLeft: '0' }, scrollDuration);
});